import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'

export const PlansWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 22px; /* stylelint-disable-line scales/space */

  ${breakpoint('sm')`
      flex-direction: row;
      gap: 28px;
  `}

  ${breakpoint('base', 'xs')`
      justify-content: space-around;
  `}
`

export const PlanPickerCardWrapper = styled.div`
  width: 100%;
`

export const SmallText = styled.small`
  display: block;
  font-size: ${({ theme }) => theme.fontSizes.D};

  pointer-events: none;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  line-height: ${({ theme }) => theme.lineHeights.E};
  margin: 16px 0;
  text-align: center;
`
